import * as React from 'react';
import { Tabber } from '../../../../designSystem/Tabber';

type CustomFormTabHeaderProps = {
    selectedTab:'answers' | 'overview',
    onClick?: (tabName: string) => void
}
export function CustomFormTabHeader(props:CustomFormTabHeaderProps):JSX.Element
{
    return (
        <Tabber variant='default'
            items={[
                { tabName:'answers', text:'Besvarelser'},
                { tabName:'overview', text:'Overblik'}
            ]}
            selectedTabName={props.selectedTab}
            onClick={props.onClick}
        />
    );
}